import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, SvgIcon, Typography } from '@mui/material';
import { PlusIcon } from 'components/SVG';
import { SparkButton } from 'sharedComponents/UI';
import { SPARK_ROUTES } from 'constants/routes';
import SparksContent from './SparkNewContent';
import SparkMainAppSearchFilters from 'components/common/SparkMainAppSearchFilters/V2';

function SparksContainer() {
  const navigate = useNavigate();

  const addSparkClick = async () => {
    navigate(SPARK_ROUTES.SPARK_BUILDER);
  };

  return (
    <>
      <Grid container justifyContent='center'>
        <Grid item alignItems='center' xs={12}>
          <Box
            display='flex'
            align-items='center'
            justifyContent='space-between'
          >
            <Typography
              variant='h4'
              sx={{
                fontFamily: 'Mont-semibold',
              }}
            >
              Sparks
            </Typography>
            <SparkButton
              variant='contained'
              startIcon={
                <SvgIcon
                  sx={{
                    '& path': {
                      fill: 'white',
                    },
                    stroke: 'white',
                  }}
                >
                  <PlusIcon color='white' width='22' height='22' />
                </SvgIcon>
              }
              onClick={addSparkClick}
            >
              <Typography
                sx={{
                  fontSize: '18px',
                  textTransform: 'capitalize',
                }}
              >
                Create Spark
              </Typography>
            </SparkButton>
          </Box>
        </Grid>
        <SparkMainAppSearchFilters placeholder='Search Sparks' />
        <SparksContent />
      </Grid>
    </>
  );
}

export default SparksContainer;
